<template>
  <div>
    <div class="Congratulations-page">
      <v-row>
        <v-col>
          <v-img
            max-height="60"
            max-width="230"
            :src="welcome_page"
            :lazy-src="welcome_page"
          >
          </v-img>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h1>Congratulations</h1>
          
        </v-col>
      </v-row>
      
      <v-row>
        <v-col>
          <p>
            Welcome to Nimeya <span>"{{full_name}}"</span> and thanks for
            signing up. Its great to have you as one of our esteemed member. We
            at Nimeya promise to make your money management simple, secure and
            interesting. We empower you to ensure that you are on top of your
            finances.
          </p>
          <p>
            With nimeya, your information is safe and secure. All information, 
            are stored in encrypted form with 256 bit encryption. We follow two 
            factor authentication process for greater security of data.
          </p>
          <p>So why wait further, start exploring <b>Nimeya</b> now...</p>
          <p style="font-size:16px;margin-top:-10px"><b>Continue to login and choose your Subscription Plan</b></p>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn class="blue-btn btn" style="margin-top:0px" @click="login"> CONTINUE TO LOGIN </v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
   import { Auth } from 'aws-amplify';
import Header from '../common/Header.vue';
export default {
  components: {Header},
	data: () => ({
		full_name:'',
		welcome_page:process.env.VUE_APP_ROOT_ICONS_URL + 'welcome.png',
	}),
	beforeCreate() {
	  Auth.currentAuthenticatedUser({
      bypassCache: false
    }).then(user => {

      this.full_name = this.capitalize(user.attributes['custom:name']);
    })
    .catch(err => {
      this.$router.push({ name: 'Login' }).catch(()=>{});
    });
	},
	methods: {
    login() {
      this.$router.push({ name: 'Login' }).catch(()=>{}); 
    },
    capitalize(string) {
      let words = string.split(' ');  
      let CapitalizedWords = [];  
      words.forEach(element => {  
          CapitalizedWords.push(element[0].toUpperCase() + element.slice(1, element.length));  
      });  
      return CapitalizedWords.join(' ');
    },
	}
}
</script>
